import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { AssetExplorerComponent } from '../../../../../pages/assets/shared/asset-explorer/asset-explorer.component';
import { SbIcons } from '@ngx-seatback/icons';

export const assetExplorer: Route = {
  path: 'asset-explorer',
  title: 'nav.assets',
  data: {
    id: RoutingID.assetExplorer,
    breadcrumb: 'nav.assets',
    icon: SbIcons.photos,
  },

  children: [
    {
      path: '',
      component: AssetExplorerComponent,
      data: {
        breadcrumb: '',
      },
    },
  ],
};
